export const menu = [
    {
      text: "當媽之後好好愛自己",
      to: 'kv'
    },
    {
      text: "3領域媽媽這樣說",
      to: 'section3'
    },
    {
      text: "以愛之名守護妳",
      to: 'section1'
    },
    {
      text: "抗老逆齡的秘密",
      to: 'section2'
    },
    {
        text: "百人體驗見證",
        to: 'section5'
    }
  ];

// export const posts = [];
export const posts = [
  {
    "name": "Jme",
    "img": "./pic/pic1.jpg",
    "desc": "一直以來都知道牛爾老師的產品很好用，京城之霜- 60植萃十全頂級全能乳擦起來不黏黏的精華霜是最愛，60種珍貴的植萃成份，東方草本精華搭配西方植物芳香調理，香味自然好聞，特別喜歡擦在有魚尾紋和法令紋的地方，再臉部按摩ㄧ下，乳狀很好吸收。"
  },
  {
    "name": "Sophia syuan",
    "img": "./pic/pic2.jpg",
    "desc": "第一次用京城之霜就立馬成為心頭好！都說乳液是最好入手的保養品，而這款十全頂級全能乳，好推勻、清爽、滋潤度又很足夠！就連我的敏感肌也都沒問題！"
  },
  {
    "name": "王O婷",
    "img": "./pic/pic3.jpg",
    "desc": "雖然十全頂級全能乳是乳狀產品，但擦起來一點不悶膚，延展性很好，不需要太多就可以全臉使用，搭配指腹按摩後就能吸收，吸收速度算蠻優異的，我也會帶到脖子不讓歲月留下痕跡，味道是舒心療癒的植萃香氣，讓我在嗅覺上也得到了一場饗宴！。"
  },
  {
    "name": "李O瑩",
    "img": "./pic/pic4.jpg",
    "desc": "生完小孩每天都很忙沒時間仔細保養，使用【京城之霜】60植萃十全頂級全能乳就不怕！一瓶滿足緊、彈、嫩、透的肌膚需求呢！整體來說我很喜歡，從商品包裝到商品使用效果都非常滿意！"
  },
  {
    "name": "肖O園",
    "img": "./pic/pic5.jpg",
    "desc": "園子每天就只有洗完臉，拍上化妝水跟精華，最後就塗抹這個全能乳，而且質地清爽好吸收！短短5天時間，真的看得到跟摸得到肌膚的變化！保濕舒緩又光澤亮麗很多！"
  },
  {
    "name": "王O婷",
    "img": "./pic/pic6.jpg",
    "desc": "成了媽媽之後才知道「時間」有多麼珍貴~每天忙裡忙外，等到終於能坐下來休息一下，早已是夜深人靜之時。保養品的選擇傾向簡單快速，1瓶就能搞定的最好！使用後的肌膚摸起來很滋潤、卻不覺黏膩，很適合夏天來使用唷！"
  },
  {
    "name": "王O慧",
    "img": "./pic/pic7.jpg",
    "desc": "連續使用幾天的心得：乳霜狀質地，有花木精油的味道，淡淡清香聞起來很舒服，滋潤度很夠，塗抹均勻後，肌膚保水度提升，很明顯感覺透亮，皮膚有比較緊緻Q彈！"
  },
  {
    "name": "李O月",
    "img": "./pic/pic8.jpg",
    "desc": "我的皮膚算敏感性皮膚，擦了很溫和沒有任何不適，如果肌膚太乾時，也可以厚敷一層，再敷上保濕面膜15分鐘，取下面膜後將剩餘精華按摩至吸收，用完後還是會想回購的！"
  },
  {
    "name": "張O惠",
    "img": "./pic/pic9.jpg",
    "desc": "想要保持美麗但就是當了媽時間不夠用啊！好在有京城之霜十全頂級全能乳！讓我賺到了時間又賺到了美麗，媽媽真的不能沒有它！"
  },
  {
    "name": "邱O茹",
    "img": "./pic/pic10.jpg",
    "desc": "用過這麼多保養品，真的第一次見到添加這麼多植萃成分！提供全方位減齡保養，成分也都都是可以幫助肌膚鎮靜修護的好物唷！一瓶滿足緊、彈、嫩、透的肌膚需求，長效保濕養潤，不黏膩無負擔！"
  },
  {
    "name": " 朱O萱",
    "img": "./pic/pic11.jpg",
    "desc": "每天上班、顧小孩，哪有時間保養！用了京城之霜十全頂級全能乳後真的回不去了！一瓶抵好幾瓶！省了時間，也讓媽媽我保持年輕，真的很推薦！"
  },
  {
    "name": "張O真",
    "img": "./pic/pic12.jpg",
    "desc": "全能乳非常好推開，散發出的是有點漢方藥草的味道，但聞起來並不會讓妳感到刺鼻不舒服，滋潤度非常到夠，擦起來不會厚重感，吸收的很快，但不會感到皮膚乾澀，皮膚的滑順感可以持續到隔天喔！"
  },
  {
    "name": "劉O萍",
    "img": "./pic/pic13.jpg",
    "desc": "因為工作+家庭兩邊要照顧，很懶得去比較保養品的好壞，所以偏好一瓶可以用很久，終於讓我找到！京城之霜十全頂級全能乳，不但滋潤度夠、清爽，最重要的是可以用到65歲！可以有好一陣子不用換保養品了！"
  },
  {
    "name": "劉O儀",
    "img": "./pic/pic14.jpg",
    "desc": "第一次使用京城之霜十全頂級全能乳，它的香氣屬於比較濃郁類型，擦上後很長時間都還能聞得到它的香味，香香的~聞起來心情也很愉悅，整體使用起來不黏膩，而且一瓶搞定！不用瓶瓶罐罐是媽媽我的心頭好！"
  },
  {
    "name": "李O婷",
    "img": "./pic/pic15.jpg",
    "desc": "愛美的我對平時的保養卻漸漸疏遠了，平日要工作下班又得照顧小孩，難免會把照顧、保養自己擺在比較後面…京城之霜60植萃十全頂級全能乳一瓶滿足肌膚保濕、美白、抗老等各種需求，不黏膩，好吸收，推推喔!當媽依然要水噹噹啊！"
  },
  {
    "name": "沈O燕",
    "img": "./pic/pic16.jpg",
    "desc": "第一次使用全能乳質地很水潤 ，摸起來較為滋養，但不會黏膩，擦在臉上的延展性很好，一下子就吸收了，用量不需要很多就可擦全臉，味道聞起來有濃郁的漢方味！使用後，肌膚摸起來很細緻，保濕度還不錯，在上妝前使用可以讓妝容感覺更加的透亮，肌膚的彈力有明顯的提升！"
  },
  {
    "name": "涵娜OO",
    "img": "./pic/pic17.jpg",
    "desc": "用了這一支之後讓我又開始對保養產生一點興趣！擠出來慢慢在臉上被推開來的瞬間讓人感覺到它滴滴珍貴，質地摸上去是偏濃郁的，塗抹完卻又很清爽！能夠讓妳明顯感覺到它很服貼，擦上去之後肌膚呈現比原來有光澤！"
  },
  {
    "name": "蕭O欣",
    "img": "./pic/pic18.jpg",
    "desc": "十全頂級全能乳，質地細滑，好推，輕薄，漢方味道，香而不濃厚，柔嫩感滿足。我喜歡植物萃取的香味，療癒阿！面子是該補一下調理起來。"
  },
  {
    "name": "林O潔",
    "img": "./pic/pic19.jpg",
    "desc": "乳液狀外觀，不只容易推抹，很快就被肌膚吸收，塗抹後，感覺肌膚有層薄薄的保護膜，摸起來沒有黏膩的感覺，有種水嫩水嫩的fu，清爽好吸收，很加分！"
  },
  {
    "name": " 柯O君 ",
    "img": "./pic/pic20.jpg",
    "desc": "為到了熟女階段，皮膚保養守重是補水保濕跟滋潤度了，牛爾京城之霜系列，可滿足所有熟齡肌的需求，持續的每天認真使用就可以發現皮膚變的水潤多，肌膚也不會乾乾又緊繃不適！ "
  },
  {
    "name": "周O薇",
    "img": "./pic/pic21.jpg",
    "desc": "我本身最愛擦起來不粘膩而且一罐抵多罐的產品～不喜歡塗塗抹抹太多東西，當媽媽需要有效率又省時間，用這罐來保養只要10秒～一臉就搞定，早晚各擦一次就好了！"
  },
  {
    "name": "陳O新",
    "img": "./pic/pic22.jpg",
    "desc": "用了幾天京城之霜60植萃十全頂級全能乳後，原本缺水的肌膚現在水份喝飽飽，摸起來滑順許多也不卡粉！有彈性，毛孔也比較細緻，明顯地比較亮，好像隨時有人幫你打光一樣！比較沒有蠟黃黃臉婆的感覺~"
  },
  {
    "name": "張Ｏ尹",
    "img": "./pic/pic23.jpg",
    "desc": "如果真心想要改善肌膚黯沉、明亮膚色、穩定膚況，可以選擇這款京城之霜60植萃十全頂級全能乳(紅霜)。長期使用下，肌膚變得相當穩定，上妝變得非常服貼，連我妹說姐姐生完小孩都回春了呢~現在愛上京城之霜的產品了！"
  },
  {
    "name": "林Ｏ玲",
    "img": "./pic/pic24.jpg",
    "desc": "長效保濕、潤澤肌膚、Q彈、抗老、除皺、改善肌膚困擾，只要一瓶輕鬆搞定！第一次體驗試用在手背上時，就被京城之霜的60植萃香氛，聞起來雅緻清新、好舒服！ "
  },
  {
    "name": "吳O慧",
    "img": "./pic/pic25.jpg",
    "desc": "質地像是乳液一樣，擦在臉上就像水一樣的化開，非常的好推勻一點也不會拉扯到肌膚，味道不像一般香精味，聞起來很舒服，上妝後也不會卡粉或是起屑屑，真的很不錯！"
  },
  {
    "name": "陳O琪",
    "img": "./pic/pic26.jpg",
    "desc": "京城之霜十全頂級全能乳，它是全能型高機能抗老精華乳，一瓶多功效很棒！很適合媽媽們沒空保養，可以很快速的做好保養，它的香味有玫塊味及清新植物味道蠻喜歡的，味道很香，擦了感覺很保濕，好推勻很快就吸收進去了，不會有黏膩感算蠻清爽的！"
  },
  {
    "name": "陳O婷",
    "img": "./pic/pic27.jpg",
    "desc": "年齡也來到了42，臉上容易產生細紋，我個人又很容易有暗沉情形，在使用10天後，覺得肌膚比較緊實有彈性，而且看起來比較亮，臉上原本有斑點的部份看起來也比較淡化喔！"
  },
  {
    "name": "陳O君",
    "img": "./pic/pic28.jpg",
    "desc": "京城之霜無疑是拯救媽媽的一個好產品，一瓶就能解決所有的程序，它的質地摸起來很滑，且保濕效果超好，我早上擦，到了下午臉上都沒有脫妝，也不乾燥，仔細看了一下成份，原來它內含「神經醯胺」這類保濕成分。有了它，媽媽不會再有油油臉囉！ "
  },
  {
    "name": "張O瑜",
    "img": "./pic/pic29.jpg",
    "desc": "京城之霜十全頂級全能乳，質地細滑，好推，輕薄，漢方味道，植物萃取的香味！在擦的時候有放鬆的感覺！延展性好的全能乳，取量不需要很多，薄薄的讓皮膚吸收即可！不需要很複雜的保養程序，快速又方便！"
  },
  {
    "name": "李O臻",
    "img": "./pic/pic30.jpg",
    "desc": "連續用了一段時間，發現肌膚變得澎澎的很是飽滿，擦上24小時後與使用前相比，皮膚鎖住了水份，肌膚的緊實度感覺更好了，有效增進皮膚濕潤度，有效舒緩乾燥的肌膚，抹開的同時感覺臉上正在補充大量的水分進入肌膚，肌膚透亮咕溜！"
  },
  {
    "name": "周O儀",
    "img": "./pic/pic31.jpg",
    "desc": "使用之後，感覺肌膚保濕柔嫩、緊緻彈潤有感，使我的肌膚全天候保持水嫩感！如果覺得肌膚疲勞乾荒的時候，60植萃十全頂級全能乳亦可厚敷搭配面膜做為加分保養！"
  },
  {
    "name": "吳O凌",
    "img": "./pic/pic32.jpg",
    "desc": "京城之霜60植萃十全頂級全能乳有股淡淡的中藥草味，舒服淡淡的氣味！全能乳不會感到粘膩非常容易塗抹，整天下來也不覺得肌膚乾燥的感覺，我覺得懶人保養其實就是快速方便效果又能持久！京城之霜應該算是首選！"
  },
  {
    "name": "洪O媛",
    "img": "./pic/pic33.jpg",
    "desc": "這款乳液是精華液質地的水凝乳，延展度很好，推起來超滑順！含有積雪草萃取液+煥顏胜肽，讓肌膚可以保濕舒緩又抗老！一瓶抵多瓶，很適合媽咪們使用喔！"
  },
  {
    "name": "陳O雅",
    "img": "./pic/pic34.jpg",
    "desc": "我的膚質偏乾、膚色偏黑又有點皮膚過敏，只要塗抹東西在臉上必定會紅腫發癢，不過這瓶全能乳沒有這個困擾，緊緻、彈嫩、不黏膩又好吸收，鎖水功能很好，一瓶搞定，就有更多時間留著搞定小孩囉！"
  },
  {
    "name": "許O梅",
    "img": "./pic/pic35.jpg",
    "desc": "使用時帶有點微微的清香感，蠻舒服的！之所以為60植萃十全頂級全能乳是因為它濃縮了東方草本精華在搭配西方的植物芳香調理，其中最加分的是它擁有高濃度積雪草+十大煥顏胜肽保養配方，有效達到抗老緊緻、保濕Q彈及亮白肌膚，讓我有好氣色！"
  },
  {
    "name": "吳O慈",
    "img": "./pic/pic36.jpg",
    "desc": "很喜歡它淡淡的香氣，有一種放鬆的感覺！質地清爽，輕盈吸收快，上一整天班也不會卡粉，京城之霜十全頂級全能乳最厲害的是它一瓶抵多瓶，一瓶就能滿足我的肌膚需求！當媽媽的也可以輕鬆有好氣色！"
  },
  {
    "name": "李O遙",
    "img": "./pic/pic37.jpg",
    "desc": "質地雖然濃郁，但是上臉很快就吸收了，使用起來很清爽，滑順延展很快，很清爽，好推勻吸收速度很快，沒有黏膩感，一整天下來真的不油膩、乾爽，滑順！"
  },
  {
    "name": "陳O珀",
    "img": "./pic/pic38.jpg",
    "desc": "這款乳液真的是我的最愛！抗老、保濕、亮白一瓶搞定！當媽媽以後時間變得很瑣碎，沒有多餘的時間讓我坐下來慢慢一瓶一瓶的擦，有了京城之霜十全頂級全能乳之後，時間大大省了下來！讚！"
  },
  {
    "name": "范O緯",
    "img": "./pic/pic39.jpg",
    "desc": "因為時間真的不夠用，很希望有個一瓶就搞定的保養品！牛爾京城之霜就是我的夢想保養品！一瓶抵全部。早晚使用，效果更看的到！預防老化改善皺紋，潤澤肌膚真的太好用了，太晚認識了！！！"
  },
  {
    "name": "方O文",
    "img": "./pic/pic40.jpg",
    "desc": "不管是一早洗完臉或是睡前洗臉完按摩都是好棒的享受！擦在手背就能感受到那種溫柔呵護的感覺！疲勞乾荒或是粗糙真的都溫和地被撫平~肌膚使用後變得很緊實有彈性！不得不說真的很十項全能的全能乳~!"
  },
  {
    "name": "徐O蕎",
    "img": "./pic/pic41.jpg",
    "desc": "每天洗完澡的保養時間是我獨享的單獨時光，雖說是獨享，但根本不能太久！所以，簡單、快速、清爽又滋潤的「懶人保養」絕對是最適合家有小孩的媽媽們的，而乳液絕對是最好入手的保養品！"
  },
  {
    "name": "江O瑜",
    "img": "./pic/pic42.jpg",
    "desc": "質地為白色的乳液狀，好塗抹好推開而且不黏膩！擦起來蠻舒服又柔滑的感覺，很適合夏天或是怕擦保養品就會悶感、黏膩感的人使用！很清爽，保濕度也夠！適合像我一樣有乾燥肌膚困擾的媽咪一起使用！"
  },
  {
    "name": "郭O葵",
    "img": "./pic/pic43.jpg",
    "desc": "雖然清爽但是可以有效舒緩肌膚乾燥的問題！蠻適合妝前使用，晚上保養讓肌膚更滋潤！京城之霜十全頂級全能乳是我目前的最愛！"
  },
  {
    "name": "陳O君",
    "img": "./pic/pic44.jpg",
    "desc": "京城之霜十全頂級全能乳質地清爽滋潤，不粘膩的特色讓我更能接受乳系列的保養品！畢竟已經不是化妝水拍拍就好的年紀了……用京城之霜不只愛自己也讓自己變得更美，不用太多的瓶瓶罐罐！一罐就能滿足我的需求。適合忙碌媽媽也適合懶人媽媽😆讓我們一起當個減齡媽媽吧！"
  },
  {
    "name": "楊O佳",
    "img": "./pic/pic45.jpg",
    "desc": "京城之霜綜合所有保養優點組成這罐全能乳液，除了可以日常保養用，皮膚太乾燥的時候更可以厚敷使用，給予乾荒肌膚即時救援！味道有淡淡的清香，不厚重很好聞，很喜歡！"
  },
  {
    "name": "顧O珊",
    "img": "./pic/pic46.jpg",
    "desc": "原本肌膚有點乾燥輕微起皮，摸起來也有輕微粗糙，使用全能乳後滋潤保濕，摸起來也Q彈滑嫩很多，妝容也變得很服服貼貼！再來是魚尾紋跟法令紋明顯的地方也淡化很多！使用起來溫和無負擔，太棒了！"
  },
  {
    "name": "游O君",
    "img": "./pic/pic47.jpg",
    "desc": "使用前的皮膚看起來略顯蠟黃無彈性，而且比較黯淡無光澤感，使用後的皮膚看起來色澤提升好幾階，而且皮膚自帶光澤感，顴骨及蘋果肌的部分感覺有滿滿的膨潤感。"
  },
  {
    "name": "蔣O臻",
    "img": "./pic/pic48.jpg",
    "desc": "敏感肌的我一用就愛上！除了成分溫和外，明顯感受到肌膚彈性變好，有光澤！最重要的是脖子上的紋路也變淡了！媽媽也能美美的，就靠它！"
  },
  {
    "name": "李O芸",
    "img": "./pic/pic49.jpg",
    "desc": "當媽之後真的比較少時間好好保養自己，每天光忙孩子就快累死了！京城之霜60植萃十全頂級全能乳，只要一瓶就能滿足所有肌膚年齡的要求，質地比乳液稍微稠，但是塗抹吸收很快速，沒有我不愛的黏膩感，特別在於味道很清香塗抹後聞起來特別舒服！"
  },
  {
    "name": "陳O沛",
    "img": "./pic/pic50.jpg",
    "desc": "保濕成份超棒的！洗完臉只需要塗抹到臉上。保養一次到位！使用上又很方便又滋潤！真的是媽媽的救星！"
  },
  {
    "name": "葉O乖",
    "img": "./pic/pic51.jpg",
    "desc": "我本身不喜歡在身上塗一些油油的東西，但是這款京城之霜，味道聞起來有淡淡的人蔘味道，而且容易吸收不油膩，也很保濕緊緻提亮！使用後明顯感覺臉的小細紋變淡了，感覺恢復到年輕有朝氣的皮膚狀態！"
  },
  {
    "name": "朱O利",
    "img": "./pic/pic52.jpg",
    "desc": "除了鎖水，更能將水分滲進肌膚裡！使用後覺得肌膚更光滑，肌膚也比較緊實還有！！！變亮了！弟弟都說媽媽妳的臉怎麼亮亮的！(自帶水嫩肌)"
  },
  {
    "name": "郭O蓉",
    "img": "./pic/pic53.jpg",
    "desc": "修復效果真的很不錯，敏感肌也可以使用！肌膚感覺更穩定也很保濕，整個人感覺都變年輕了！成為媽媽以後，真的很需要這瓶京城之霜十全頂級全能乳！"
  },
  {
    "name": "陳O元",
    "img": "./pic/pic54.jpg",
    "desc": "從原本肌膚沒彈性，沒光澤，多虧了這瓶京城之霜十全頂級全能乳讓我回復年輕好光彩！好像回到了20歲！推薦給被說是黃臉婆的媽媽們！年輕原來這麼簡單！"
  },
  {
    "name": "陳O亮",
    "img": "./pic/pic55.jpg",
    "desc": "本身是敏感肌，保養品都很怕月擦越敏感，這瓶京城之霜十全頂級全能乳完全的修復力極佳，成分溫和也好吸收！用完會明顯感覺臉上帶光喔！"
  },
  {
    "name": "詹O琳",
    "img": "./pic/pic56.jpg",
    "desc": "在使用全能乳後，不管是塗抹在臉上或手上後，讓我的肌膚變得緊緻、彈潤、透亮，一次滿足我這個懶懶的女人，畢竟本身很討厭塗抹瓶瓶罐罐很多還有油膩不好推的保養品，而全能乳不但好推且不油膩，使用起來很清爽，味道也非常好聞！"
  },
  {
    "name": "葉O華",
    "img": "./pic/pic57.jpg",
    "desc": "洗完臉後，在臉上抹上十全頂級全能乳，不油不膩很清爽，同時有保濕感和緊緻感，很好推勻而且在短時間即可完成保養，還帶著舒服宜人的香氣，連小孩都說媽媽好好聞，對帶三寶的忙綠跪婦來說，十全頂級全能乳是媽媽能快速保養的神物！"
  },
  {
    "name": "李O萱",
    "img": "./pic/pic58.jpg",
    "desc": "京城之霜十全頂級全能乳好推好吸收！清爽又不油膩！重點一瓶抵十瓶，從今天起我不用再花一堆錢買瓶瓶罐罐，只要這一瓶就夠了！"
  },
  {
    "name": "陳O軒",
    "img": "./pic/pic59jpg",
    "desc": "隔天起床發現皮膚摸起來也如絲質般的柔滑！極潤的效果冬天使用絕對很給力，也因為是清爽的乳液所以夏天使用也不用擔心過油，白天上妝前我也會使用讓肌膚保水度更好，妝感更服貼喔！"
  },
  {
    "name": "江O如",
    "img": "./pic/pic60.jpg",
    "desc": "早晚都使用，讓我的臉部再鬧乾荒！很喜歡它的味道以及它的質地，非常清爽好推，一瓶就可以完成臉部的保養，是懶媽媽必備的神器啊！"
  },
  {
    "name": "謝O蓁",
    "img": "./pic/pic61.jpg",
    "desc": "本身是T字部位容易出油、兩頰容易乾燥又容易長痘痘的膚質，三寶媽保養自己的時間真的是少之又少，收到試用品的時間剛好是生理期前，正是皮膚狀況最差的時候，就趁這個機會讓媽媽好好享受十全頂級全能乳的滋潤！"
  },
  {
    "name": "曾O華",
    "img": "./pic/pic62.jpg",
    "desc": "質地很潤延展性很好～而且包裝有60種植萃印在上面，真的感覺有另類的安心感！我自己是偏油性肌膚，化妝水後薄擦一層，其實還蠻舒服的！不會覺得悶或者黏膩！隔天起床臉真的變的澎澎彈彈的，這點還蠻驚豔的！"
  },
  {
    "name": "陳O芯",
    "img": "./pic/pic63.jpg",
    "desc": "京城之霜60植萃十全頂級全能乳，好吸收不會有黏膩感，有讓皮膚提拉的感覺，還能讓皮膚不會因為洗臉後的緊繃感，是修護肌膚的好選擇！"
  },
  {
    "name": "黃O佳",
    "img": "./pic/pic64.jpg",
    "desc": "京城之霜十全頂級全能乳能幫助恢復和保持皮膚的天然保濕屏障，提升肌膚防護力，給予肌膚深層保濕效果，皮膚有變Q彈，我用了一陣子，臉摸起來的細緻感完全大提升！個人感覺很滿意，值得推薦！"
  },
  {
    "name": "胡O蕊",
    "img": "./pic/pic65.jpg",
    "desc": "香味適中，似乎帶有一點點人蔘味，不會有過香的問題！白色乳液狀，延展性剛好，上手上臉後肌膚保濕度也不錯，微微黏但又不會有厚重的感覺，整體感覺不錯。"
  },
  {
    "name": "王O樺",
    "img": "./pic/pic66.jpg",
    "desc": "最近忙碌到每每洗完澡就想倒頭就睡，根本無法抹太多瓶瓶罐罐的我，十全頂級全能乳就能一瓶搞定我的需求，超適合忙碌的媽媽，縮時保養省時省力超方便！"
  },
  {
    "name": "陳O雯",
    "img": "./pic/pic67.jpg",
    "desc": "塗抹京城之霜十全頂級全能乳感覺肌膚明顯透亮、水嫩嫩，不斷聞到臉上飄來淡淡清香，一邊按摩保養臉部肌膚一邊有種讓人做草本SPA的感覺！"
  },
  {
    "name": "劉O",
    "img": "./pic/pic68.jpg",
    "desc": "用了幾天，目前都沒出現過敏也沒有亂長莫名小疹子，雖不知能不能抗老，但至少維持肌膚保溼度，減少乾皮狀況是讓我比較明顯有感！越來越期待使用完這瓶後，是否能從阿珠媽變成小姐姐，母親節要到了，這麼棒的的好物，姐姐妹妹一起趁優惠檔期把貨屯起來吧！"
  },
  {
    "name": "葉O萍",
    "img": "./pic/pic69.jpg",
    "desc": "質地是很剛好的乳狀，非常好推勻，有一點滋潤感及帶著水感，味道淡淡的清香跟天然的中藥香味很好聞。剛好最近天氣漸漸變熱，擦起來還不至於過於油膩，我很喜歡60植萃十全頂級全能乳帶來的肌膚柔嫩感！"
  },
  {
    "name": "黃O玉",
    "img": "./pic/pic70.jpg",
    "desc": "京城之霜十全頂級全能乳是質地輕盈的米白色乳液，有一種迷人漢方草本的香味，聞起來香香的，是會讓人心情愉快的味道。溫溫和和的，好推勻好吸收，卻不黏膩！使用之後，相當輕透又保濕。可以說是省時又省力的肌膚保養的小幫手喔~"
  },
  {
    "name": "林O晴",
    "img": "./pic/pic71.jpg",
    "desc": "這款產品真的很適合送給平常辛苦的媽媽們，當媽之後真的該更懂得好好愛自己～這樣all in one的產品也很適合平時忙碌的媽媽們使用，就算沒有太多的保養時間，還是能擦一罐產品就把保養做到位！"
  },
  {
    "name": "鄧O慧",
    "img": "./pic/pic72.jpg",
    "desc": "它是一條含有修護、抗老、保濕的乳液，最適合炎夏不愛\"瓶瓶罐罐\"保養的我！很清爽濕潤的滑順感，感覺皮膚多了一層防護，連續使用除了增加肌膚的緊實彈性以外，也能感覺到肌膚水潤Q彈！隨時都能保持最好的狀態！"
  },
  {
    "name": "施O含",
    "img": "./pic/pic73.jpg",
    "desc": "京城之霜的十全頂級全能乳深得我心，淡黃色的乳液一抹開肌膚就能感受到水潤感，幫乾燥的兩頰注入水份，抹起來清爽不黏膩，很好吸收。而且淡淡的植萃香氣聞起來很舒服！每次抹完鵝子都會捧著我的臉猛聞說好香！除了保濕，還能亮白、緊緻，對抗肌膚老化，堪稱全能乳液王！"
  },
  {
    "name": "蘇O婷",
    "img": "./pic/pic74.jpg",
    "desc": "一瓶速戰速決的全能乳最能符合我的懶人保養需求！這款京城之霜帶有獨特的草本香味，屬於舒服的嗅覺，我習慣在臉部清潔後或睡前輕抹薄薄的一層，隔天可以明顯感受肌膚變得較為保濕與透亮，富含水份的肌膚彈性也跟著提升！雖然我是麻煩的混合型肌膚，但卻可以被此款全能乳輕鬆駕馭！"
  },
  {
    "name": "楊O嬅",
    "img": "./pic/pic75.jpg",
    "desc": "緊實肌膚，對抗皺紋～使用完整個皮膚感覺變很亮，水嫩有彈性！這幾天感冒睡不好，黑眼圈都跑出來了，流鼻水鼻子很紅擦破皮，趕快用京城之霜急救一下，皮膚有得到舒緩的感覺！"
  },
  {
    "name": "江O容",
    "img": "./pic/pic76.jpg",
    "desc": "看到積雪草讓我更加確定這是我所需要的保養品了，積雪草是保養品中可以用來修復肌膚、撫平細紋的好物。打開來時有一股淡淡的中藥香氣，味道不會過香，而且讓我心動的是它有17種抗老成份和一瓶抵多瓶，看到這兩點就讓我愛不釋手！"
  },
  {
    "name": "阮O君",
    "img": "./pic/pic77.jpg",
    "desc": "成分溫和，乳霜質地，在皮膚上很好推勻，也不會有過多黏膩感，是清爽舒服的。好吸收，有保濕舒緩的效果，用了之後，覺得自己的皮膚變得更為水潤，讓肌膚恢復比較健康的光澤。最喜歡睡前，利用小孩睡著的時間，來好好照顧自己，讓自己的肌膚有一段好好修護的時光，讓膚質狀態更為穩定！"
  },
  {
    "name": "王O珺",
    "img": "./pic/pic78.jpg",
    "desc": "一款超好用的乳液必備條件：好推勻、清爽滋潤度、適合各種膚質。而京城之霜經典之一的全能乳，是一款盈潤不黏膩的「精華級」抗老凝乳，5%積雪草萃取和60植萃成分，提供全方位減齡保養，一瓶滿足緊、彈、嫩、透的肌膚需求！"
  },
  {
    "name": "李O芳",
    "img": "./pic/pic79.jpg",
    "desc": "我覺得擦起來不會有油膩感，很好擦上去。感受了幾天，發現它比他牌乳液保濕，也很濕潤，讓我的臉摸起來超好摸、QQ的有彈性。希望也能改善細紋，讓皺紋也消失無蹤，保持青春的模樣！"
  },
  {
    "name": "葉O婷",
    "img": "./pic/pic80.jpg",
    "desc": "本來以為年過40青春肌不會再出現在臉上！京城之霜十全頂級全能乳完全拯救媽媽我！除了明顯細紋減少，也讓我的臉更加亮白緊緻，這一次真的要好好愛自己一下了！"
  },
  {
    "name": "陳O萍",
    "img": "./pic/pic81.jpg",
    "desc": "原本氣色暗沈的我擦了全能乳後整個亮起來了！才擦幾天就明顯的感受到肌膚的滋潤！女人過了30真的不能不服老……該做的保養還是得做啊！京城之霜十全頂級全能乳一瓶搞定，真的輕鬆不少！"
  },
  {
    "name": "陳O芳",
    "img": "./pic/pic82.jpg",
    "desc": "隔天起床洗臉時，肌膚摸起來還有咕溜咕溜的觸感！就連上妝也會服貼許多不浮粉或是卡粉，畢竟歲月不饒人，不能當媽了就變成可怕的黃臉婆！京城之霜60植萃十全頂級全能乳就超適合像我們！時間緊迫又懶人型媽媽不需要太多複雜的步驟，也能輕鬆保養無負擔！"
  },
  {
    "name": "謝O璇",
    "img": "./pic/pic83.jpg",
    "desc": "質地為乳白色乳液狀，推開時非常的滑順好推且不黏膩好吸收，肌膚感覺變得更緊實有彈性，有一種肌膚被滋潤呵護的感覺，真不愧是美容教主牛爾老師自創品牌啊！第一次使用就讓我愛上它了。"
  },
  {
    "name": "蔣O霖",
    "img": "./pic/pic84.jpg",
    "desc": "連續使用一周下來，覺得最明顯的就是臉變亮了，不再有之前照顧兩隻暗沉好久的黃臉婆樣子，每天早上洗臉都可以摸到滑溜溜保濕的臉龐，心情都愉悅起來！京城之霜十全頂級全能乳是近期使用過非常有效果的產品，榮登我心目中這次的母親節禮物首選啊！"
  },
  {
    "name": "蔡O佳",
    "img": "./pic/pic85.jpg",
    "desc": "京城之霜味道好聞不刺鼻，質地不黏膩，用起來不厚重又好推勻，效果好又便宜！清爽又好用，沒有加香精，成分好又沒有亂添加，用起來很安心也很實在！"
  },
  {
    "name": "陳O寧",
    "img": "./pic/pic86.jpg",
    "desc": "這款京城之霜 60植萃十全頂級全能乳對我來說真的是一瓶可以抵多瓶的保養好物，整個超給力的啦！非常適合給像我這樣沒空保養又懶惰的人使用了！"
  },
  {
    "name": "劉O娟",
    "img": "./pic/pic87.jpg",
    "desc": "聞到天然植萃的味道，是我最愛成分天然的保養品，擦起來感覺很保濕卻不黏膩，含有5%的積雪草，讓我的肌膚更有彈力，還能抗老、美白、保濕，一瓶抵多瓶，真是物超所值啊！"
  },
  {
    "name": "漢O莓",
    "img": "./pic/pic88.jpg",
    "desc": "乳液帶點淡黃色的色澤，淡淡的漢方草本味，味道我個人也很喜歡，質地很輕盈好推延，延展性佳推開時，可以感到到質地不黏膩不厚重，好推勻質地清爽又滋潤，能給予肌膚足夠的滋潤度，很好吸收吸收後的膚觸變得柔嫩細緻許多，持續天天使用能提供肌膚長效的保水感，是很好用的全能乳！"
  },
  {
    "name": "張O廷",
    "img": "./pic/pic89.jpg",
    "desc": "忙碌的媽咪就需要這款快速保養！一瓶抵十瓶，京城之霜十全頂級全能乳，輕盈好吸收，不黏膩，讓縮時保養這件是再簡單不過了！謝謝你京城之霜，讓我恢復年輕肌！"
  },
  {
    "name": "賴O鳳",
    "img": "./pic/pic90.jpg",
    "desc": "它的延展性非常的好，最讓我驚豔的地方就是瞬間吸收，感覺不到它在肌膚表面停留過！肌膚徹底得到滋潤。不會油、不會過於滋潤，不會厚重，簡直零負擔！"
  },
  {
    "name": "張O琳",
    "img": "./pic/pic91.jpg",
    "desc": "四十歲後的女人更該懂得好好愛自己！這是這幾年的領悟，年輕時的好膚質靜悄悄離我而去，不再好好注意保養肌膚問題真的不行。換季時的乾燥紅腫發癢問題，使用完約一週的時間慢慢獲得改善。"
  },
  {
    "name": "田O瑄",
    "img": "./pic/pic92.jpg",
    "desc": "京城之霜十全頂級全能乳真的很讓我驚豔！臉上的細紋明顯變淡，最重要的是我不需要塗塗抹抹很多保養品！只要一瓶就足夠了！質地好推好吸收！是目前使用最滿意的乳液！"
  },
  {
    "name": "吳O嘉",
    "img": "./pic/pic93.jpg",
    "desc": "世上最多的就是懶女人，我就是其中之一！所以當看到一瓶抵十瓶就很吸引我！沒想到真的很令人滿意！美白、保濕、穩定膚況，好推好吸收！用過就會愛上！當媽以後就靠京城之霜十全頂級全能乳來好好愛自己吧！"
  }
]
